export const isModule10 = (barCode: string) => {
  const thirdDigit = barCode[2];
  return ['6', '7'].includes(thirdDigit);
};

export const getModule10FromCodePart = (codePart: string) => {
  let totalSum = 0;
  let weight = 2;

  codePart.split('').reverse().forEach((value: string) => {
    let weightedValue = parseInt(value, 10) * weight;

    if (weightedValue >= 10) {
      weightedValue = 1 + (weightedValue - 10);
    }

    totalSum += weightedValue;

    if (weight === 2) {
      weight = 1;
      return;
    }
    weight = 2;
  });

  let digit = 10 - (totalSum % 10);
  if (digit === 10) {
    digit = 0;
  }

  return digit.toString();
};

export const validateModule10 = (code: string) => {
  const codeSize = code.length - 1;
  const verifierDigit = code[codeSize];

  const codeWithoutVerifierDigit = code.slice(0, codeSize);

  const splitReversedCode = codeWithoutVerifierDigit.split('').reverse();

  let totalSum = 0;

  splitReversedCode.forEach((value: string, index: number) => {
    const isEven = index % 2 === 0;
    const currentDigitMultiplied = Number(value) * (isEven ? 2 : 1);

    /**
     * Quando a soma tiver mais de 1 algarismo (ou seja, maior que 9),
     * soma-se os algarismos antes de somar com somatório
     */
    if (currentDigitMultiplied > 9) {
      const splitSum = currentDigitMultiplied.toString().split('');
      const parsedSplitSum = splitSum.map(num => parseInt(num, 10));

      totalSum += parsedSplitSum.reduce((sum, current) => sum + current);
      return;
    }
    totalSum += currentDigitMultiplied;
  });
  /**
   * Dezena imediatamente superior ao somatório (dezena superior de 25 é 30, a de 43 é 50...)
   */
  const totalSumSuperiorDozen = Math.ceil(totalSum / 10) * 10;
  const totalSumSuperiorDozenDifference = totalSumSuperiorDozen - totalSum;

  return totalSumSuperiorDozenDifference === Number(verifierDigit) ? undefined : 'Módulo 10 inválido';
};



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/validator/validateBarcode/validateModule10/index.ts